class SiteNavigation {
    constructor() {
        this.headerSection = document.querySelector('#shopify-section-header-v2 ');
        this.mainNavDrawer = document.querySelector('#main-nav-outter');
        this.mainNav = document.querySelector('#main-nav');
        this.mainNavUl = document.querySelector('#main-nav ul');
        this.mainNavItemsThatDontHaveMegaMenus = document.querySelectorAll('.main-nav-parent a');
        this.mainNavItemsThatHaveMegaMenus = document.querySelectorAll('span.has-mega-menu');
        this.allMegaMenus = document.querySelectorAll('.mega-menu');
        this.allLevel2LinksLis = document.querySelectorAll('.mega-menu-links li');
        this.linksForThirdLevelMenus = document.querySelectorAll('.link-for-third-level-links');
        this.pageOverlay = document.querySelector('#page-overlay');

        this.showMobileMenuBtn = document.querySelector('#show-mobile-menu-btn');
        this.closeMobileMenuBtn = document.querySelector('#close-mobile-menu-btn');
    }

    static desktopTopLevelNavLinkClick(href)
    {
        if (window.innerWidth >= 992) {
            location.href = href; 
        }
    }

    addEventListeners() {
        const context = this;

        // hovering over normal menu links with no mega menus attached
        this.mainNavItemsThatDontHaveMegaMenus.forEach(function (mainNavItem) {
            mainNavItem.addEventListener('mouseover', function () {
                if (window.innerWidth >= 992)
                {
                    context.hideAllMegaMenus(context);
                }
            });
        });

        // hovering over mega menu parent links
        this.mainNavItemsThatHaveMegaMenus.forEach(function (mainNavItem) {
            
            mainNavItem.addEventListener('mouseover', function () {
                if (window.innerWidth >= 992)
                {
                    // show mega menu
                    const megaMenuFor = mainNavItem.dataset.forMegaMenu;
                    context.toggleMegaMenu(megaMenuFor);

                    // add active class - must come after the toggle function
                    mainNavItem.classList.add('active');
                }
                
            });

            mainNavItem.addEventListener('click', function(){
                if (window.innerWidth < 992)
                {
                    // show mega menu
                    const megaMenuFor = mainNavItem.dataset.forMegaMenu;
                    context.toggleMegaMenu(megaMenuFor);

                    // add active class - must come after the toggle function
                    mainNavItem.classList.add('active');
                    
                    // (mobile only) add mobile hidden class to main nav ul
                    context.mainNavUl.classList.add('mobile-hidden');
                }
                
            });
        });

        this.allLevel2LinksLis.forEach(function (link) {
            let showLevel3 = function()
            {
                context.allLevel2LinksLis.forEach(function (li) {
                    // hide all third level menus
                    let thirdLevelMenus = document.querySelectorAll('.third-level-menu');
                    thirdLevelMenus.forEach(function (m) {
                        m.style.display = 'none';
                    });
                    // unmark active class
                    li.classList.remove('active');
                });
                let thirdLevelMenuLink = link.querySelector('span.link-for-third-level-links');
                if (thirdLevelMenuLink != null) {
                    context.showThirdLevelMenu(thirdLevelMenuLink.dataset.thirdLevelMenu, link);
                }

                // hide "hide level 2" button
                const allHideLevel2Buttons = document.querySelectorAll('.hide-level-2');
                allHideLevel2Buttons.forEach(function(btn){
                    btn.style.display = 'none';
                });

                // show "hide level 3" button
                const hideLevel3Button = document.querySelector(`.hide-level-3[data-hide-third-level-for="${thirdLevelMenuLink.dataset.thirdLevelMenu}"]`);
                hideLevel3Button.style.display = 'block';
            }

            link.addEventListener('mouseover', function () {
                if (window.innerWidth >= 992)
                {
                    showLevel3();
                }
            })
            link.addEventListener('click', function(){
                showLevel3();
            });
        });

        document.addEventListener('mousemove', function () {
            // toggle page overlay (desktop only)
            if (window.innerWidth > 992)
            {
                const hasOpennedMegaMenu = Array.from(context.allMegaMenus).filter(el => el.style.display === 'block').length > 0;
                // show overlay if any of the mega menus are open
                if (hasOpennedMegaMenu) {
                    context.showPageOverlay();
                }
                else {
                    // else hide overlay
                    context.pageOverlay.classList.remove('active');
                    context.hidePageOverlay();
                    context.closeDrawer();
                }
            }
        });
      
        // hide all mega menus and hide page overlay on click of page overlay
        this.pageOverlay.addEventListener('click', function () {
            context.closeDrawer();
        });

        let scrollTimeout;
        window.addEventListener('scrollend', function () {
            // collapse nav on scroll down (for desktop only)
        //     if (this.window.innerWidth >= 992)
        //     {
        //         const headerMiddle = document.getElementById('header-middle');
        //         const quarterPage = document.body.scrollHeight / 10;

        //         // Clear the previous timer to debounce
        //         clearTimeout(scrollTimeout);

        //         // Set a new timer
        //         scrollTimeout = setTimeout(function () {
        //             const scrollPosition = window.scrollY;

        //             if (scrollPosition >= quarterPage) {
        //                 // hide middle row (logo)
        //                 headerMiddle.classList.add('hidden-v2');
        //                 // make header sticky
        //                 context.headerSection.style.position = 'sticky';
        //             } else {
        //                 // show middle row (logo)
        //                 headerMiddle.classList.remove('hidden-v2');
        //                 // un-sticky the header
        //                 context.headerSection.style.position = 'relative';
        //             }
        //         }, 0); // adjust delay (ms) as needed
        //     }           
         });
    }

    toggleMobileNavDrawer() {
        if (this.mainNavDrawer.classList.contains('drawer-open')) {
            this.closeDrawer();
        }
        else {
            this.openDrawer();
        }
    }

    openDrawer() {
        this.mainNavDrawer.classList.add('drawer-open');
        this.showPageOverlay();
        this.showMobileMenuBtn.style.display = 'none';
        this.closeMobileMenuBtn.style.display = 'block';
    }

    closeDrawer() {
        this.mainNavDrawer.classList.remove('drawer-open');
        this.hidePageOverlay();
        // set all main parent navs back to show
        this.mainNavUl.classList.remove('mobile-hidden');
        this.showMobileMenuBtn.style.display = 'block';
        this.closeMobileMenuBtn.style.display = 'none';
        this.reset();
    }

    toggleMegaMenu(megaMenuFor) {
        let context = this;
        this.hideAllMegaMenus();
        let megaMenu = document.querySelector(`.mega-menu[data-mega-menu="${megaMenuFor}"]`);
        megaMenu.style.display = 'block';

        let megaMenuInner = megaMenu.querySelector('.mega-menu-inner');
        megaMenuInner.addEventListener('mouseleave', function () {
            if (window.innerWidth >= 992)
            {
                context.hideAllMegaMenus(context);
            }
        });
    }

    showThirdLevelMenu(thirdLevelMenuHandle, linkPressed) {
        const context = this;
        // mark this link as active while we are on it
        linkPressed.classList.add('active');
        linkPressed.parentElement.classList.add('mobile-hidden');
        // hide all third level menus first
        this.hideThirdLevelMenus();

        // show this third level menu
        const thirdLevelMenu = document.querySelector(`.third-level-menu[data-third-level-menu-for="${thirdLevelMenuHandle}"]`);
        thirdLevelMenu.style.display = 'block';

        thirdLevelMenu.addEventListener('mouseleave', function () {
            if (window.innerWidth >= 992)
            {
                thirdLevelMenu.style.display = 'none';
                // unmark the second-level menu as active
                context.removeClass('active', '.mega-menu-links li.active');
            }
            
        });
    }

    hideAllMegaMenus(optionalContext) {
        const context = typeof optionalContext != 'undefined' && optionalContext != null ? optionalContext : this;

        // hide all mega menus 
        if (typeof context.allMegaMenus != 'undefined') {
            context.allMegaMenus.forEach(function (megaMenu) {
                megaMenu.style.display = 'none';
            });
        }

        // remove active class on main parent nav item
        context.removeClass('active', 'span.has-mega-menu');
    }

    mobileHideSecondLevel(secondLevelHandle)
    {
        // class="mega-menu container" data-mega-menu
        const megaMenu = document.querySelector('.mega-menu[data-mega-menu="'+secondLevelHandle+'"]');
        megaMenu.style.display = 'none';
        this.mainNavUl.classList.remove('mobile-hidden');
    }

    mobileHideThirdLevel(thirdLevelHandle)
    {
        // hide all third-level menus
        this.hideThirdLevelMenus();

        // hide the 'hide level 3' button
        const allHideLevelThreeButtons = document.querySelectorAll('.hide-level-3');
        allHideLevelThreeButtons.forEach(function(btn){
            btn.style.display = 'none';
        });

        // re-show the second level menu and its buttons
        let allLevel2HiddenMenus = document.querySelectorAll('.mega-menu-links.mobile-hidden');
        allLevel2HiddenMenus.forEach(function(l2menu){
            l2menu.classList.remove('mobile-hidden');
        });

        let allLevel2HideBtns = document.querySelectorAll('.hide-level-2');
        allLevel2HideBtns.forEach(function(btn){
            btn.style.display = 'block';
        });

    }

    hideThirdLevelMenus() {
        let thirdLevelMenus = document.querySelectorAll('.third-level-menu');
        thirdLevelMenus.forEach(function (thirdLevelMenu) {
            thirdLevelMenu.style.display = 'none';
        });
    }

    togglePageOverlay() {
        if (this.pageOverlay.classList.contains('active')) {
            this.hidePageOverlay();
        }
        else {
            this.showPageOverlay();
        }
    }

    showPageOverlay()
    {
        this.pageOverlay.classList.add('active')
        //document.body.classList.add('locked_mobile');
        //document.documentElement.classList.add('locked_mobile');
    }

    hidePageOverlay()
    {
        this.pageOverlay.classList.remove('active');
        //document.body.classList.remove('locked_mobile');
       // document.documentElement.classList.remove('locked_mobile');
    }

    removeClass(className, selector) {
        let elements = document.querySelectorAll(selector);
        elements.forEach(function (el) {
            el.classList.remove(className);
        });
    }

    reset()
    {
        this.hideAllMegaMenus(this);
        this.mobileHideThirdLevel("");
        this.hidePageOverlay();
    }
}